module.exports = __webpack_public_path__ + "media/images/factory-300e5cdb26a2b1b9abc57f7a74bbb991.svg";